module.exports = __webpack_public_path__ + "img/i1.6d6fc625.png";